import PropTypes from 'prop-types';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell, LabelList } from 'recharts';

const TopProductosChart = ({ data = [] }) => {
  const COLORS = ['#8b5cf6', '#3b82f6', '#06b6d4', '#10b981', '#f59e0b'];

  // Función para acortar nombres largos si es necesario
  const formatYAxis = (tickItem) => {
    return tickItem.length > 15 ? `${tickItem.substring(0, 15)}...` : tickItem;
  };

  return (
    <div className="statistics-chart">
      <h3 className="statistics-title">Ventas por Producto</h3>
      <div style={{ width: '100%', height: 350 }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart 
            data={data} 
            layout="vertical" 
            margin={{ top: 5, right: 50, left: 20, bottom: 5 }} // Aumentamos márgenes
          >
            <XAxis type="number" hide /> 
            <YAxis 
              dataKey="producto" 
              type="category" 
              width={40} // Aumentado para dar más espacio al texto
              tickFormatter={formatYAxis} // Acorta nombres muy largos
              tick={{ fontSize: 11, fill: '#6b7280', fontWeight: 500 }} 
            />
            <Tooltip 
              cursor={{ fill: 'transparent' }}
              contentStyle={{ borderRadius: '8px', border: 'none', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}
            />
            <Bar 
              dataKey="cantidad" 
              radius={[0, 4, 4, 0]} 
              barSize={25}
            >
              {data.map((entry, index) => (
                <Cell key={entry.producto} fill={COLORS[index % COLORS.length]} />
              ))}
              {/* Muestra el número al final de la barra para mejor visibilidad */}
              <LabelList dataKey="cantidad" position="right" style={{ fontSize: '12px', fontWeight: 'bold', fill: '#374151' }} />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

TopProductosChart.propTypes = {
  data: PropTypes.array,
};

export default TopProductosChart;